import { useEffect, useState } from "react";
import { useLocation } from "common/src/router/compat";
import i18n from "i18next";
import { AUTH_TOKEN_EVENT } from "../helpers/constants";
import { getToken } from "../helpers/session";
import {
  didFullBundleFail,
  isFullLoaded,
  isIndexPath,
  loadFullBundle,
} from "../helpers/localizationBundle";

export default function EnsureFullLocalization() {
  const { pathname } = useLocation();
  const [authTick, setAuthTick] = useState(0);

  useEffect(() => {
    const onAuth = () => setAuthTick((tick) => tick + 1);
    window.addEventListener(AUTH_TOKEN_EVENT, onAuth);
    return () => window.removeEventListener(AUTH_TOKEN_EVENT, onAuth);
  }, []);

  const onIndex = isIndexPath(pathname);
  const loggedIn = Boolean(getToken());

  useEffect(() => {
    if (onIndex && loggedIn && !isFullLoaded() && !didFullBundleFail()) {
      loadFullBundle(i18n);
    }
  }, [onIndex, loggedIn, authTick]);

  if (!onIndex && !isFullLoaded() && !didFullBundleFail()) {
    throw loadFullBundle(i18n);
  }

  return null;
}
